import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface LoginDialogProps {
  onClose: () => void;
  onLogin: (username: string, password: string) => Promise<boolean>;
}
export function LoginDialog({
  onClose,
  onLogin
}: LoginDialogProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const success = await onLogin(username, password);
      if (!success) {
        setError('Ungültige Anmeldedaten');
      }
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50" data-id="element-531">
      <div className="bg-white rounded-lg p-6 w-[400px] max-w-full" data-id="element-532">
        <div className="flex justify-between items-center mb-4" data-id="element-533">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-534">
            Login erforderlich
          </h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700" data-id="element-535">
            <XIcon size={20} data-id="element-536" />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-537">
          <div data-id="element-538">
            <label className="block text-sm text-gray-700 mb-1" data-id="element-539">
              Benutzername
            </label>
            <input type="text" value={username} onChange={e => setUsername(e.target.value)} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:border-[#3498dd]" disabled={isLoading} data-id="element-540" />
          </div>
          <div data-id="element-541">
            <label className="block text-sm text-gray-700 mb-1" data-id="element-542">Passwort</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full px-3 py-2 border rounded text-sm focus:outline-none focus:border-[#3498dd]" disabled={isLoading} data-id="element-543" />
          </div>
          {error && <p className="text-sm text-red-600" data-id="element-544">{error}</p>}
          <div className="flex justify-end gap-2" data-id="element-545">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded" disabled={isLoading} data-id="element-546">
              Abbrechen
            </button>
            <button type="submit" disabled={isLoading} className="relative px-4 py-2 text-sm text-white bg-[#3498dd] hover:bg-blue-600 rounded flex items-center min-w-[90px] justify-center disabled:bg-blue-400" data-id="element-547">
              {isLoading ? <>
                  <div className="w-4 h-4 rounded-full border-2 border-white border-t-transparent animate-spin mr-2" data-id="element-548"></div>
                  <span data-id="element-549">Anmelden...</span>
                </> : 'Anmelden'}
            </button>
          </div>
        </form>
      </div>
    </div>;
}